var _rect, _rect2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCiclesBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 241,
    viewBox: "0 0 241 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.8516,
    y: 120.262,
    width: 146.244,
    height: 146.244,
    rx: 73.1219,
    transform: "rotate(-45 16.8516 120.262)",
    fill: "url(#paint0_linear_37_1054)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3263,
    y: 120.262,
    width: 120.119,
    height: 120.119,
    rx: 60.0596,
    transform: "rotate(-45 35.3263 120.262)",
    stroke: "#1A2024",
    strokeWidth: 1.50557
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.0646,
    y: 120.262,
    width: 168.57,
    height: 168.57,
    rx: 84.2849,
    transform: "rotate(-45 1.0646 120.262)",
    stroke: "#E7FF00",
    strokeWidth: 1.50557
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_1054",
    x1: 89.9735,
    y1: 120.262,
    x2: 89.9735,
    y2: 266.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D428"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiclesBackground);
export default __webpack_public_path__ + "static/media/CiclesBackground.4bcdb6d3a9032661c4956080f436c486.svg";
export { ForwardRef as ReactComponent };